/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/skip-backward-icon/skip-backward-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=skip-backward-icon.component.css.map */
